import { render, staticRenderFns } from "./RemoteSetting.vue?vue&type=template&id=ab9465cc&scoped=true"
import script from "./RemoteSetting.vue?vue&type=script&lang=js"
export * from "./RemoteSetting.vue?vue&type=script&lang=js"
import style0 from "./RemoteSetting.vue?vue&type=style&index=0&id=ab9465cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9465cc",
  null
  
)

export default component.exports